// Get first image url. Support both legacy and new image formats.
const getFirstImageUrl = (value: unknown): string | null => {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) {
    const firstImage = value[0];
    return firstImage &&
      typeof firstImage === 'object' &&
      typeof firstImage.source === 'string'
      ? firstImage.source
      : null;
  }
  return null;
};

export default getFirstImageUrl;
